import { RefObject, useEffect, useRef, useState } from 'react';

type ObserverRect = Omit<DOMRectReadOnly, 'toJSON'>;

export const useResizeObserver = (): [RefObject<HTMLDivElement>, ObserverRect | undefined] => {
  const ref = useRef<HTMLDivElement>(null);
  const [rect, setRect] = useState<ObserverRect>();

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver(() => {
      const boundingRect = ref.current?.getBoundingClientRect();
      setRect(boundingRect);
    });
    observer.observe(ref?.current);

    return (): void => observer.disconnect();
  }, [ref]);

  return [ref, rect];
};

export default useResizeObserver;
